// Chuyển từ VUONGDATWOOD_V2/src/features/cong-luong/catalog.ts
import { defaultPayrollUnit } from './domain';

export const PAYROLL_VARIABLE_GROUPS = [
    'Năng suất',
    'Công và phép',
    'Tăng ca',
    'Lương thỏa thuận',
    'Phụ cấp',
    'Giữ lại',
    'Bảo hiểm',
    'Thuế',
    'Khấu trừ',
    'Tổng hợp',
];

// Chỉ khai đơn vị cho biến không suy được từ kiểu dữ liệu; còn lại TIEN là Đồng, TY_LE là %.
const UNITS = {
    NC: 'Ngày', PN: 'Ngày', NL: 'Ngày', NCT: 'Ngày', NCC: 'Ngày',
    GTC: 'Giờ', GIO_CC: 'Giờ',
    HSL_TC: 'Hệ số',
    KLNS: 'Kg', SLL: 'Lồng', DG_GL_KL: 'Đồng/kg', DG_LONG: 'Đồng/lồng',
};

function variable(code, name, kind, source, formula, group, dataType = 'TIEN', initialValue = null) {
    return {
        code,
        name,
        kind,
        source,
        formula,
        group,
        dataType,
        unit: UNITS[code] ?? (defaultPayrollUnit(dataType) || null),
        // Mức hằng số công ty khai lúc khởi tạo, chỉ có nghĩa với biến Hệ thống nguồn Hệ thống.
        initialValue,
    };
}

// Biểu thuế TNCN lũy tiến từng phần theo phương pháp rút gọn. Chỉ là mức khởi tạo: khi Nhà nước
// đổi biểu thuế, kế toán sửa công thức của TNCN ở màn Cấu hình công lương và khai ngày hiệu lực.
const PAYROLL_TAX_FORMULA = [
    'ROUND(IFS(',
    'TNTT <= 5000000, TNTT * 0.05,',
    'TNTT <= 10000000, TNTT * 0.1 - 250000,',
    'TNTT <= 18000000, TNTT * 0.15 - 750000,',
    'TNTT <= 32000000, TNTT * 0.2 - 1650000,',
    'TNTT <= 52000000, TNTT * 0.25 - 3250000,',
    'TNTT <= 80000000, TNTT * 0.3 - 5850000,',
    'TRUE, TNTT * 0.35 - 9850000', '), 0)',
].join(' ');

export const PAYROLL_CATALOG_VARIABLES = [
    variable('LSP', 'LƯƠNG SẢN PHẨM', 'HE_THONG', 'NANG_SUAT', null, 'Năng suất'),
    // Khối lượng kg của các tổ người này phụ trách: mỗi tổ lấy một công đoạn (các công đoạn cùng tổ
    // ra cùng số kg), rồi cộng các tổ. Dùng cho tiền giữ lại theo khối lượng của tổ trưởng.
    variable('KLNS', 'KHỐI LƯỢNG TỔ PHỤ TRÁCH', 'HE_THONG', 'NANG_SUAT', null, 'Năng suất', 'SO'),
    // Tiền giữ lại (theo bảng lương thực tế): một phần PCTN và một khoản theo khối lượng tổ được
    // giữ lại, chưa trả trong kỳ; Sổ tiền giữ lại cộng dồn từ các kỳ đã duyệt.
    variable('TL_GL_PCTN', 'TỶ LỆ GIỮ LẠI PCTN', 'THOA_THUAN', 'THOA_THUAN', null, 'Giữ lại', 'TY_LE'),
    variable('PCTN_GL', 'PCTN GIỮ LẠI', 'CONG_THUC', 'CONG_THUC', 'ROUND(PCTN * TL_GL_PCTN / 100, 0)', 'Giữ lại'),
    variable('PCTN_TL', 'PCTN THỰC LÃNH', 'CONG_THUC', 'CONG_THUC', 'PCTN - PCTN_GL', 'Giữ lại'),
    variable('DG_GL_KL', 'ĐƠN GIÁ GIỮ LẠI THEO KHỐI LƯỢNG', 'THOA_THUAN', 'THOA_THUAN', null, 'Giữ lại'),
    variable('KL_GL', 'TIỀN GIỮ LẠI THEO KHỐI LƯỢNG', 'CONG_THUC', 'CONG_THUC', 'ROUND(KLNS * DG_GL_KL, 0)', 'Giữ lại'),
    variable('GL', 'TỔNG TIỀN GIỮ LẠI KỲ NÀY', 'CONG_THUC', 'CONG_THUC', 'PCTN_GL + KL_GL', 'Giữ lại'),
    variable('TLSP', 'TỔNG LƯƠNG SẢN PHẨM', 'CONG_THUC', 'CONG_THUC', 'LSP + PCTN_TL - KL_GL', 'Năng suất'),
    variable('SLL', 'SỐ LỒNG BB62', 'NHAP_TAY', 'NHAP_KY', null, 'Phụ cấp', 'SO'),
    variable('DG_LONG', 'ĐƠN GIÁ PHỤ CẤP LỒNG', 'HE_THONG', 'HE_THONG', null, 'Phụ cấp', 'TIEN', 8_000),
    variable('PCL', 'PHỤ CẤP LỒNG', 'CONG_THUC', 'CONG_THUC', 'SLL * DG_LONG', 'Phụ cấp'),
    variable('TTN', 'TRỪ TIỀN NGHỈ', 'NHAP_TAY', 'NHAP_KY', null, 'Khấu trừ'),
    variable('NC', 'NGÀY CÔNG', 'NHAP_TAY', 'NHAP_KY', null, 'Công và phép', 'SO'),
    variable('PN', 'NGÀY PHÉP HƯỞNG LƯƠNG', 'HE_THONG', 'PHEP_NAM', null, 'Công và phép', 'SO'),
    variable('NL', 'NGÀY LỄ HƯỞNG LƯƠNG', 'HE_THONG', 'NGAY_LE', null, 'Công và phép', 'SO'),
    variable('GIO_CC', 'GIỜ CÔNG CHUẨN MỖI NGÀY', 'HE_THONG', 'HE_THONG', null, 'Công và phép', 'SO', 8),
    variable('NCT', 'TỔNG NGÀY HƯỞNG LƯƠNG', 'CONG_THUC', 'CONG_THUC', 'NC + PN + NL', 'Công và phép', 'SO'),
    variable('MLT', 'MỨC LƯƠNG THÁNG', 'THOA_THUAN', 'THOA_THUAN', null, 'Lương thỏa thuận'),
    variable('NCC', 'NGÀY CÔNG CHUẨN', 'THOA_THUAN', 'THOA_THUAN', null, 'Lương thỏa thuận', 'SO'),
    variable('LTH', 'LƯƠNG THÁNG THỰC NHẬN', 'CONG_THUC', 'CONG_THUC', 'ROUND(MLT / NCC * NCT, 0)', 'Lương thỏa thuận'),
    variable('DGN', 'ĐƠN GIÁ NGÀY', 'THOA_THUAN', 'THOA_THUAN', null, 'Lương thỏa thuận'),
    variable('LN', 'LƯƠNG NGÀY', 'CONG_THUC', 'CONG_THUC', 'NCT * DGN', 'Công và phép'),
    variable('LK', 'LƯƠNG KHOÁN', 'THOA_THUAN', 'THOA_THUAN', null, 'Lương thỏa thuận'),
    variable('GTC', 'GIỜ TĂNG CA', 'NHAP_TAY', 'NHAP_KY', null, 'Tăng ca', 'SO'),
    variable('HSL_TC', 'HỆ SỐ LƯƠNG TĂNG CA', 'HE_THONG', 'HE_THONG', null, 'Tăng ca', 'SO', 1.5),
    variable('DGTC', 'ĐƠN GIÁ TĂNG CA', 'THOA_THUAN', 'THOA_THUAN', null, 'Tăng ca'),
    variable('TTC', 'TIỀN TĂNG CA', 'CONG_THUC', 'CONG_THUC', 'GTC * DGTC', 'Tăng ca'),
    variable('DGPCC', 'ĐƠN GIÁ CƠM MỖI NGÀY', 'THOA_THUAN', 'THOA_THUAN', null, 'Phụ cấp'),
    variable('PCC', 'PHỤ CẤP CƠM', 'CONG_THUC', 'CONG_THUC', 'NC * DGPCC', 'Phụ cấp'),
    variable('PCTN', 'PHỤ CẤP TRÁCH NHIỆM', 'THOA_THUAN', 'THOA_THUAN', null, 'Phụ cấp'),
    variable('PCNT', 'PHỤ CẤP NHÀ TRỌ', 'THOA_THUAN', 'THOA_THUAN', null, 'Phụ cấp'),
    variable('PCK', 'PHỤ CẤP KHÁC', 'NHAP_TAY', 'NHAP_KY', null, 'Phụ cấp'),
    variable('UNG', 'TRỪ ỨNG', 'HE_THONG', 'UNG_LUONG', null, 'Khấu trừ'),
    // Bảo hiểm và thuế: tỷ lệ và mức giảm trừ là hằng số công ty, lương đóng bảo hiểm và số người
    // phụ thuộc là thỏa thuận từng người, còn lại là công thức.
    variable('TL_BHXH_NLD', 'TỶ LỆ BHXH NGƯỜI LAO ĐỘNG', 'HE_THONG', 'HE_THONG', null, 'Bảo hiểm', 'TY_LE', 8),
    variable('TL_BHYT_NLD', 'TỶ LỆ BHYT NGƯỜI LAO ĐỘNG', 'HE_THONG', 'HE_THONG', null, 'Bảo hiểm', 'TY_LE', 1.5),
    variable('TL_BHTN_NLD', 'TỶ LỆ BHTN NGƯỜI LAO ĐỘNG', 'HE_THONG', 'HE_THONG', null, 'Bảo hiểm', 'TY_LE', 1),
    variable('TL_BHXH_DN', 'TỶ LỆ BHXH DOANH NGHIỆP', 'HE_THONG', 'HE_THONG', null, 'Bảo hiểm', 'TY_LE', 17.5),
    variable('TL_BHYT_DN', 'TỶ LỆ BHYT DOANH NGHIỆP', 'HE_THONG', 'HE_THONG', null, 'Bảo hiểm', 'TY_LE', 3),
    variable('TL_BHTN_DN', 'TỶ LỆ BHTN DOANH NGHIỆP', 'HE_THONG', 'HE_THONG', null, 'Bảo hiểm', 'TY_LE', 1),
    variable('TL_CD_DN', 'TỶ LỆ KINH PHÍ CÔNG ĐOÀN', 'HE_THONG', 'HE_THONG', null, 'Bảo hiểm', 'TY_LE', 2),
    variable('LDBH', 'LƯƠNG ĐÓNG BẢO HIỂM', 'THOA_THUAN', 'THOA_THUAN', null, 'Bảo hiểm'),
    variable('BHXH_NLD', 'BHXH NGƯỜI LAO ĐỘNG', 'CONG_THUC', 'CONG_THUC', 'ROUND(LDBH * TL_BHXH_NLD / 100, 0)', 'Bảo hiểm'),
    variable('BHYT_NLD', 'BHYT NGƯỜI LAO ĐỘNG', 'CONG_THUC', 'CONG_THUC', 'ROUND(LDBH * TL_BHYT_NLD / 100, 0)', 'Bảo hiểm'),
    variable('BHTN_NLD', 'BHTN NGƯỜI LAO ĐỘNG', 'CONG_THUC', 'CONG_THUC', 'ROUND(LDBH * TL_BHTN_NLD / 100, 0)', 'Bảo hiểm'),
    variable('BH_NLD', 'TỔNG BẢO HIỂM NGƯỜI LAO ĐỘNG', 'CONG_THUC', 'CONG_THUC', 'BHXH_NLD + BHYT_NLD + BHTN_NLD', 'Bảo hiểm'),
    variable('BHXH_DN', 'BHXH DOANH NGHIỆP', 'CONG_THUC', 'CONG_THUC', 'ROUND(LDBH * TL_BHXH_DN / 100, 0)', 'Bảo hiểm'),
    variable('BHYT_DN', 'BHYT DOANH NGHIỆP', 'CONG_THUC', 'CONG_THUC', 'ROUND(LDBH * TL_BHYT_DN / 100, 0)', 'Bảo hiểm'),
    variable('BHTN_DN', 'BHTN DOANH NGHIỆP', 'CONG_THUC', 'CONG_THUC', 'ROUND(LDBH * TL_BHTN_DN / 100, 0)', 'Bảo hiểm'),
    variable('CD_DN', 'KINH PHÍ CÔNG ĐOÀN', 'CONG_THUC', 'CONG_THUC', 'ROUND(LDBH * TL_CD_DN / 100, 0)', 'Bảo hiểm'),
    variable('MIEN_PCC', 'MỨC MIỄN THUẾ PHỤ CẤP CƠM', 'HE_THONG', 'HE_THONG', null, 'Thuế', 'TIEN', 730_000),
    variable('GTBT', 'GIẢM TRỪ BẢN THÂN', 'HE_THONG', 'HE_THONG', null, 'Thuế', 'TIEN', 11_000_000),
    variable('GTNPT_1', 'GIẢM TRỪ MỖI NGƯỜI PHỤ THUỘC', 'HE_THONG', 'HE_THONG', null, 'Thuế', 'TIEN', 4_400_000),
    variable('SO_NPT', 'SỐ NGƯỜI PHỤ THUỘC', 'THOA_THUAN', 'THOA_THUAN', null, 'Thuế', 'SO'),
    variable('GTNPT', 'GIẢM TRỪ NGƯỜI PHỤ THUỘC', 'CONG_THUC', 'CONG_THUC', 'SO_NPT * GTNPT_1', 'Thuế'),
    // Tăng ca miễn thuế toàn phần, phụ cấp cơm miễn tới mức trần — viết thẳng vào công thức.
    variable('TNCT', 'THU NHẬP CHỊU THUẾ', 'CONG_THUC', 'CONG_THUC', 'MAX(TC - TTC - MIN(PCC, MIEN_PCC), 0)', 'Thuế'),
    variable('TNTT', 'THU NHẬP TÍNH THUẾ', 'CONG_THUC', 'CONG_THUC', 'MAX(TNCT - BH_NLD - GTBT - GTNPT, 0)', 'Thuế'),
    variable('TNCN', 'THUẾ THU NHẬP CÁ NHÂN', 'CONG_THUC', 'CONG_THUC', PAYROLL_TAX_FORMULA, 'Thuế'),
    variable('GK', 'GIẢM KHÁC', 'NHAP_TAY', 'NHAP_KY', null, 'Khấu trừ'),
    variable('TC', 'TỔNG CỘNG', 'CONG_THUC', 'CONG_THUC', 'LSP + LN + LK + TTC + PCC + PCTN + PCNT + PCK', 'Tổng hợp'),
    variable('TCHI', 'THỰC CHI', 'CONG_THUC', 'CONG_THUC', 'TC - UNG - BH_NLD - TNCN - GK', 'Tổng hợp'),
];

// LDBH và SO_NPT phải là cột thật của mẫu: màn thỏa thuận chỉ hỏi giá trị của các biến Thỏa thuận
// có trong cột của mẫu, để ở dạng phụ thuộc ngầm thì không có chỗ nhập và bảo hiểm, thuế mãi bằng 0.
const COMMON_DEDUCTIONS = ['UNG', 'LDBH', 'BH_NLD', 'SO_NPT', 'TNCN', 'GK', 'TCHI'];
const COMMON_ALLOWANCES = ['GTC', 'DGTC', 'TTC', 'DGPCC', 'PCC', 'PCTN', 'PCNT', 'PCK'];

// Mẫu lương ngày suy đơn giá tăng ca từ đơn giá ngày. Làm tròn ở TTC chứ không ở DGTC:
// 250.000/8*1,5 = 46.875, làm tròn đơn giá trước rồi nhân 5 giờ ra 235.000, đúng phải là 234.000.
const OVERTIME_FROM_DAILY_RATE = {
    DGTC: 'DGN / GIO_CC * HSL_TC',
    TTC: 'ROUND(GTC * DGTC, -3)',
};

export const PAYROLL_DEFAULT_TEMPLATES = [
    {
        // Theo bảng lương sản phẩm thực tế của công ty (tổ Vòng, tổ CD), thứ tự cột như file Excel.
        // TNCT viết lại thành TC: mẫu này không có tăng ca và cơm nên kết quả như công thức chung, nhưng
        // để công thức chung thì mẫu kéo ngầm GTC, DGTC, DGPCC vào ô nhập và form thỏa thuận.
        code: 'LUONG_SAN_PHAM', name: 'Lương sản phẩm',
        variables: [
            'LSP', 'KLNS', 'PCTN', 'TL_GL_PCTN', 'PCTN_TL', 'PCTN_GL', 'DG_GL_KL', 'KL_GL', 'GL', 'TLSP',
            'SLL', 'DG_LONG', 'PCL', 'PCK', 'TC',
            'TTN', 'LDBH', 'BH_NLD', 'SO_NPT', 'TNCT', 'TNCN', 'UNG', 'TCHI',
        ],
        required: [],
        hidden: ['TNCT'],
        formulas: {
            TC: 'TLSP + PCL + PCK',
            TNCT: 'MAX(TC, 0)',
            TCHI: 'TC - TTN - UNG - BH_NLD - TNCN',
        },
    },
    {
        code: 'LUONG_NGAY_CONG', name: 'Lương ngày công',
        variables: ['NC', 'PN', 'NL', 'NCT', 'DGN', 'LN', ...COMMON_ALLOWANCES, 'TC', ...COMMON_DEDUCTIONS],
        required: ['DGN'],
        formulas: { ...OVERTIME_FROM_DAILY_RATE, TC: 'LN + TTC + PCC + PCTN + PCNT + PCK' },
    },
    {
        code: 'LUONG_THEO_THANG', name: 'Lương theo tháng',
        variables: ['NC', 'PN', 'NL', 'NCT', 'MLT', 'NCC', 'LTH', ...COMMON_ALLOWANCES, 'TC', ...COMMON_DEDUCTIONS],
        required: ['MLT', 'NCC'],
        formulas: {
            LTH: 'ROUND(MLT / NCC * NCT, 0)',
            TC: 'LTH + TTC + PCC + PCTN + PCNT + PCK',
        },
    },
];

export const PAYROLL_REQUIRED_CODES = PAYROLL_CATALOG_VARIABLES.map((item) => item.code);
export const PAYROLL_REQUIRED_TEMPLATE_CODES = PAYROLL_DEFAULT_TEMPLATES.map((item) => item.code);

// Ngày bắt đầu hiệu lực của dữ liệu khởi tạo: đặt đủ sớm để kỳ cũ cũng tìm thấy mức.
export const PAYROLL_SEED_EFFECTIVE_FROM = '2020-01-01';

/**
 * Dữ liệu khởi tạo cho các bảng AppSheet. Như V2: hằng số và đời công thức đầu tiên hiệu lực từ mốc
 * sớm; chỉ biến nguồn NHAP_KY mới cho phép nhập trên bảng lương. Khác V2: chỉ khoản mà thiếu thì
 * lương bằng 0 mới bắt buộc (DGN, MLT, NCC), còn phụ cấp, cơm, bảo hiểm tùy người nên để trống được.
 */
export function buildPayrollSeedRows() {
    const variableByCode = new Map(PAYROLL_CATALOG_VARIABLES.map((item) => [item.code, item]));
    const variables = PAYROLL_CATALOG_VARIABLES.map((item, index) => ({
        'MÃ BIẾN': item.code,
        'TÊN BIẾN': item.name,
        'LOẠI BIẾN': item.kind,
        'NGUỒN DỮ LIỆU': item.source,
        'KIỂU DỮ LIỆU': item.dataType,
        'ĐƠN VỊ': item.unit ?? '',
        'CÔNG THỨC': item.formula ?? '',
        'NHÓM': item.group,
        'THỨ TỰ': index + 1,
        'HOẠT ĐỘNG': true,
        'MÔ TẢ': item.name,
    }));
    const constants = PAYROLL_CATALOG_VARIABLES
        .filter((item) => item.initialValue != null)
        .map((item) => ({
            'ID': `HS-${item.code}`,
            'MÃ BIẾN': item.code,
            'HIỆU LỰC TỪ': PAYROLL_SEED_EFFECTIVE_FROM,
            'HIỆU LỰC ĐẾN': '',
            'GIÁ TRỊ': item.initialValue,
            'GHI CHÚ': 'Khởi tạo',
            'NGƯỜI TẠO': 'system',
            'NGÀY CẬP NHẬT': PAYROLL_SEED_EFFECTIVE_FROM,
        }));
    const formulas = PAYROLL_CATALOG_VARIABLES
        .filter((item) => item.formula)
        .map((item) => ({
            'ID': `CT-${item.code}`,
            'MÃ BIẾN': item.code,
            'HIỆU LỰC TỪ': PAYROLL_SEED_EFFECTIVE_FROM,
            'HIỆU LỰC ĐẾN': '',
            'CÔNG THỨC': item.formula,
            'GHI CHÚ': 'Khởi tạo',
            'NGƯỜI TẠO': 'system',
            'NGÀY CẬP NHẬT': PAYROLL_SEED_EFFECTIVE_FROM,
        }));
    const templates = PAYROLL_DEFAULT_TEMPLATES.map((item) => ({
        'MÃ MẪU': item.code,
        'TÊN MẪU': item.name,
        'MÔ TẢ': '',
        'HOẠT ĐỘNG': true,
        'DS TỔ': '',
        'DS NHÂN SỰ': '',
        'DS LOẠI TRỪ': '',
        'PHIÊN BẢN': 1,
        'KHÓA THAY ĐỔI': false,
        'NGƯỜI TẠO': 'system',
    }));
    const templateColumns = PAYROLL_DEFAULT_TEMPLATES.flatMap((template) => template.variables.map((code, index) => ({
        'ID': `${template.code}|${code}`,
        'MÃ MẪU': template.code,
        'MÃ BIẾN': code,
        'CÔNG THỨC': template.formulas[code] ?? '',
        'THỨ TỰ': index + 1,
        'BẮT BUỘC': template.required.includes(code),
        'HIỂN THỊ': !(template.hidden ?? []).includes(code),
        'CHO PHÉP NHẬP': variableByCode.get(code)?.source === 'NHAP_KY',
    })));
    return { variables, constants, formulas, templates, templateColumns };
}
